import { useEffect } from 'react';
import { datadogInit } from '~/lib/datadog';
import { useAuth } from '~/providers/AuthProvider';

export const useTrackingProviders = () => {
  const { token } = useAuth();

  useEffect(() => {
    datadogInit({ userToken: token });
  }, [token]);
};
